import request from '@/utils/request';

/**
 * 优惠券 列表
 * @param params
 */
export function marketingProductCouponListApi(params) {
  return request({
    url: '/admin/marketing/productCoupon/list',
    method: 'get',
    params: params
  });
}

/**
 * 优惠券 修改状态
 * @param pram
 */
export function productCouponIssueStatusApi(params) {
  return request({
    url: '/admin/marketing/productCoupon/update/status',
    method: 'post',
    params: params
  });
}

/**
 * 优惠券 删除
 * @param pram
 */
export function productCouponDeleteApi(params) {
  return request({
    url: '/admin/marketing/productCoupon/delete',
    method: 'post',
    params: params
  });
}

/**
 * 优惠券 发送
 * @param pram
 */
export function productCouponSaveApi(data) {
  return request({
    url: '/admin/marketing/productCoupon/add',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 发送
 * @param pram
 */
export function productCouponEditApi(id, data) {
  return request({
    url: '/admin/marketing/productCoupon/edit?id=' + id,
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 详情
 * @param pram
 */
export function productCouponInfoApi(params) {
  return request({
    url: '/admin/marketing/productCoupon/info',
    method: 'post',
    params: params
  });
}

/**
 * 优惠券 详情
 * @param pram
 */
export function productCouponOrderApi(params) {
  return request({
    url: "/admin/marketing/productCoupon/order/list",
    method: 'get',
    params: params
  });
}
export function couponOrderRefuseApi(params) {
  return request({
    url: '/admin/marketing/productCoupon/order/refund/refuse',
    method: 'GET',
    params: params
  });
}
export function couponOrderRefundApi(params) {
  return request({
    url: '/admin/marketing/productCoupon/order/refund',
    method: 'GET',
    params: params
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
export function couponOrderExcelApi(params) {
  return request({
    url: "/admin/export/excel/couponOrder",
    method: 'get',
    params: params
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
export function couponOrderStatisticsExcelApi(params) {
  return request({
    url: "/admin/marketing/productCoupon/order/statistics",
    method: 'get',
    params: params
  });
}